//Axios 拦截
import axios from "axios";
import Api from "@/components/Api/index.js";
import { Message, Loading } from "element-ui";
import store from "@/store/index";
import Vue from "vue";
const ConfigBaseURL = process.env.VUE_APP_SERVE; //默认路径，这里也可以使用env来判断环境
const ConfigBaseURLNew = process.env.VUE_APP_SERVE_NEW; //默认路径，这里也可以使用env来判断环境
let loadingInstance = null; //这里是loading
export const configBaseURL = function() {
  return ConfigBaseURL
}
export const configBaseURLNew = function() {
  return ConfigBaseURLNew
}

//使用create方法创建axios实例
export const Service = axios.create({
  timeout: 30000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "get",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export const NewService = axios.create({
  timeout: 30000, // 请求超时时间
  baseURL: ConfigBaseURLNew,
  method: "get",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});


//文件上传
export const ServiceFile = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "get",
});

//文件下载
export const ServiceFileDownLoadFiles = axios.create({
  timeout: 30000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "post",
  responseType: "blob",
});

ServiceFileDownLoadFiles.interceptors.request.use((config) => {
  config.headers.accessToken = store.state.accessToken;
  return config;
});

// 添加请求拦截器
NewService.interceptors.request.use((config) => {
  config.headers.token = store.state.newAccessToken;
  return config;
});
// 添加响应拦截器
NewService.interceptors.response.use(
  (response) => {
    if (response.data.statusText === "token已过期") {
      Message({ type: "warning", message: "身份验证失效或已在别处登录！" });
      store.commit("closeLogin");
    }
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加请求拦截器
Service.interceptors.request.use((config) => {
  config.headers.accessToken = store.state.accessToken;
  const tokenTime = JSON.parse(localStorage.getItem("tokenTime"));
  //token过期时间
  //如果当前时间 - 上一次存进vuex的时间  剩余的时间在10分钟内 请求接口更新token
  if (
    !(
      config.url.includes("user/login") ||
      config.url.includes("user/refreshTokenC")
    )
  ) {
    //600000
    if (tokenTime - Date.now() <= 600000 && tokenTime - Date.now() > 0) {
      console.log("sx", "进来刷新token");
      new Api("oauth").updateToken(store.state.refreshToken).then((res) => {
        if (res.status == 200) {
          store.commit("setAccessToken", res.data.accessToken);
          store.commit("setRefreshToken", res.data.refreshToken);
          localStorage.setItem(
            "tokenTime",
            JSON.stringify(res.data.exp * 1000 + Date.now())
          );
        }
      });
    } else if (tokenTime - Date.now() < 0) {
      //在俩个小时内用户没有操作，token 完全过期,清除原有token，跳转到登陆页面
      store.commit("closeLogin");
    }
  }
  return config;
});
// 添加响应拦截器
Service.interceptors.response.use(
  (response) => {
    if (response.data.status === 401) {
      router.push({
        path: "/",
      });
      Message({ type: "warning", message: "身份验证失效或已在别处登录！" });
      store.commit("closeLogin");
    }
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
